module.exports = __webpack_public_path__ + "static/media/main idea.cdb511b5.mp3";